const mapStyle = [
	{
		featureType: 'administrative',
		elementType: 'labels.text.fill',
		stylers: [
			{
				color: '#444444',
			},
		],
	},
	{
		featureType: 'administrative.country',
		elementType: 'geometry',
		stylers: [
			{
				visibility: 'on',
			},
		],
	},
	{
		featureType: 'administrative.country',
		elementType: 'labels.text',
		stylers: [
			{
				weight: '0.01',
			},
			{
				saturation: '100',
			},
		],
	},
	{
		featureType: 'landscape',
		elementType: 'all',
		stylers: [
			{
				color: '#ffffff',
			},
		],
	},
	{
		featureType: 'poi',
		elementType: 'all',
		stylers: [
			{
				visibility: 'off',
			},
		],
	},
	{
		featureType: 'road',
		elementType: 'all',
		stylers: [
			{
				saturation: -100,
			},
			{
				lightness: 45,
			},
		],
	},
	{
		featureType: 'road',
		elementType: 'labels.text.fill',
		stylers: [
			{
				color: '#373737',
			},
		],
	},
	{
		featureType: 'road.highway',
		elementType: 'all',
		stylers: [
			{
				visibility: 'simplified',
			},
		],
	},
	{
		featureType: 'road.arterial',
		elementType: 'labels.icon',
		stylers: [
			{
				visibility: 'off',
			},
		],
	},
	{
		featureType: 'transit',
		elementType: 'all',
		stylers: [
			{
				visibility: 'off',
			},
		],
	},
	{
		featureType: 'water',
		elementType: 'all',
		stylers: [
			{
				color: '#04343F',
			},
			{
				visibility: 'on',
			},
		],
	},
];

/*id of map here*/
// if ($("#map").length > 0) {
// 	window.addEventListener("load", initializeMap);
// }
// if ($("#multi-map").length > 0) {
// 	window.addEventListener("load", initialize_map);
// }

// async function initializeMap() {
// 	const mapCanvas = document.getElementById("map");
// 	const coordsDynamic = mapCanvas.getAttribute("data-coords");
// 	const splittedCoords = coordsDynamic.split(",");
// 	const myLatLng = new google.maps.LatLng(splittedCoords[0], splittedCoords[1]);

// 	const mapOptions = {
// 		zoom: 15,
// 		gestureHandling: "cooperative",
// 		center: myLatLng,
// 		mapTypeId: google.maps.MapTypeId.ROADMAP,
// 		styles: mapStyle,
// 		scrollwheel: false,
// 	};

// 	const map = new google.maps.Map(mapCanvas, mapOptions);
// 	const iconSource =
// 		window.location.origin + "/arodamoscollections/wp-content/themes/arodamoscollection/assets/images/marker.png";

// 	// As of February 21st, 2024, google.maps.Marker is deprecated.
// 	// Please use google.maps.marker.AdvancedMarkerElement instead.
// 	// At this time, google.maps.Marker is not scheduled to be discontinued,
// 	// but google.maps.marker.AdvancedMarkerElement is recommended over google.maps.Marker.

// 	const marker = new google.maps.Marker({
// 		map: map,
// 		position: myLatLng,
// 		icon: {
// 			url: iconSource,
// 		},
// 	});

// 	// While google.maps.Marker will continue to receive bug fixes for any major regressions,
// 	// existing bugs in google.maps.Marker will not be addressed.
// 	// At least 12 months notice will be given before support is discontinued.

// 	marker.setAnimation(google.maps.Animation.BOUNCE);
// 	setTimeout(() => {
// 		marker.setAnimation(null);
// 	}, 1000);
// }

// function initialize_map() {
// 	const coords_dynamic = jQuery("#multi-map").attr("data-coords");
// 	let locations;

// 	try {
// 		locations = JSON.parse(coords_dynamic);
// 	} catch (e) {
// 		// If JSON parsing fails, assume it's a single coordinate string
// 		locations = [{ Coords: coords_dynamic }];
// 	}

// 	// Center map on the first location
// 	const firstLocationCoords = locations[0].Coords.split(",");
// 	const myLatlng = new google.maps.LatLng(parseFloat(firstLocationCoords[0]), parseFloat(firstLocationCoords[1]));

// 	const mapOptions = {
// 		zoom: 10, // Adjust zoom level as needed
// 		gestureHandling: "cooperative",
// 		center: myLatlng,
// 		mapTypeId: google.maps.MapTypeId.ROADMAP,
// 		styles: mapStyle,
// 		scrollwheel: false,
// 	};

// 	const map = new google.maps.Map(document.getElementById("multi-map"), mapOptions);
// 	const bounds = new google.maps.LatLngBounds();
// 	const iconsource = "/arodamoscollections/wp-content/themes/arodamoscollection/assets/images/marker.png";

// 	locations.forEach(function (location) {
// 		const coords = location.Coords.split(",");
// 		const latLng = new google.maps.LatLng(parseFloat(coords[0]), parseFloat(coords[1]));

// 		const marker = new google.maps.Marker({
// 			position: latLng,
// 			icon: {
// 				url: iconsource,
// 			},
// 			map: map,
// 		});

// 		marker.setAnimation(google.maps.Animation.BOUNCE);
// 		setTimeout(function () {
// 			marker.setAnimation(null);
// 		}, 1000);

// 		bounds.extend(latLng);
// 	});

// 	// Adjust map to fit all markers
// 	map.fitBounds(bounds);

// 	// Optional: Add custom map style
// 	const styledMap = new google.maps.StyledMapType(mapStyle, {
// 		name: "Styled Map",
// 	});
// 	map.mapTypes.set("mapStyle", styledMap);
// 	map.setMapTypeId("mapStyle");
// }

window.addEventListener('load', () => {
	const mapEl = document.querySelector('#map');
	if (mapEl) {
		initializeDynamicMap(mapEl);
	}
});

async function initializeDynamicMap(mapEl) {
	const coordsData = mapEl.getAttribute('data-coords');
	const isMulti = coordsData.trim().startsWith('[');
	let locations = [];

	try {
		if (isMulti) {
			locations = JSON.parse(coordsData);
		} else {
			locations = [{ Coords: coordsData }];
		}
	} catch (e) {
		console.error('Failed to parse map coordinates:', e);
		return;
	}
	const iconSource = "https://www.elafonisi-resort.com/wp-content/themes/elafonisi-resort-new/assets/images/marker.png";
	console.log(iconSource)
	const bounds = new google.maps.LatLngBounds();

	// Determine center (first marker by default)
	const firstCoords = locations[0].Coords.split(',');
	const centerLatLng = new google.maps.LatLng(parseFloat(firstCoords[0]), parseFloat(firstCoords[1]));

	const mapOptions = {
		zoom: isMulti ? 10 : 15,
		center: centerLatLng,
		gestureHandling: 'cooperative',
		mapTypeId: google.maps.MapTypeId.ROADMAP,
		styles: mapStyle,
		scrollwheel: false,
	};

	const map = new google.maps.Map(mapEl, mapOptions);

	locations.forEach((location) => {
		const [lat, lng] = location.Coords.split(',').map((coord) => parseFloat(coord.trim()));
		const latLng = new google.maps.LatLng(lat, lng);

		const marker = new google.maps.Marker({
			position: latLng,
			map,
			icon: { url: iconSource },
		});

		marker.setAnimation(google.maps.Animation.BOUNCE);
		setTimeout(() => marker.setAnimation(null), 1000);

		bounds.extend(latLng);
	});

	if (isMulti && locations.length > 1) {
		map.fitBounds(bounds);
	}

	const styledMap = new google.maps.StyledMapType(mapStyle, { name: 'Styled Map' });
	map.mapTypes.set('mapStyle', styledMap);
	map.setMapTypeId('mapStyle');
}
